import { useEffect, useState } from "react";
import "./CookieBanner.css";
import { COOKIE_KEY, enableMetrika } from "./metrika";
import Button from "../Button/Button";

export default function CookieBanner() {
    const [active, setActive] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_KEY);

        if (consent === "accepted") {
            setVisible(false);
            enableMetrika(); // включаем сразу, т.к. уже было согласие
            return;
        }

        if (consent === "denied") {
            setVisible(false);
            return;
        }

        setVisible(true);
        const timer = setTimeout(() => setActive(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    const acceptCookies = () => {
        localStorage.setItem(COOKIE_KEY, "accepted");
        setVisible(false);
        enableMetrika();
    };

    const denyCookies = () => {
        localStorage.setItem(COOKIE_KEY, "denied");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookieBanner_body">
            <div className={"cookieBanner " + (active ? "cookieAnimation" : "")}>
                <p>Мы используем файлы cookie и сервис Яндекс.Метрика для анализа поведения пользователей.</p>
                <p>Если Вы согласны их предоставить нажмите «Принять».</p>

                <div>
                    <Button typeButton={"button"} onClick={acceptCookies} >
                        Принять
                    </Button>
                    <Button typeButton={"button"} onClick={denyCookies} reject={true}>
                        Отклонить
                    </Button>
                </div>
            </div>
        </div>
    );
}
